import React from "react";

import Form from "@Components/Form";
import { URLS, ATTENDANCE_TYPE_URL, STORAGE_CONSTANT } from "configs/constants";
import { getAssignedModule } from "utils";
import eightAxios from "configs/axiosConfig";
import { useParams, useHistory } from "react-router-dom";
import { useNotifyContext } from "@Components/Notify";

const initialValues = {
  status: "",
  code: "",
  acronym: "",
  name: "",
  active: false,
  year: "",
};

const AttendanceTypeDetail = () => {
  const history = useHistory();
  const params = useParams();
  const setNotify = useNotifyContext();

  const formFields = [
    {
      type: "renderonly",
      key: "code",
      name: "code",
      label: "Code",
      required: true,
      disabledText: ["0000"],
    },
    {
      type: "renderonly",
      key: "acronnym",
      name: "acronym",
      label: "Acronym",
      required: true,
    },
    {
      type: "renderonly",
      key: "name",
      name: "name",
      label: "Name",
      required: true,
      disabledText: ["Others", "Hari Terabai - Bayar Penuh"],
    },
    {
      type: "renderonly",
      key: "multiply",
      name: "multiply",
      label: "Multiply",
    },
    {
      type: "renderonly",
      name: "status",
      key: "status",
      label: "Status",
      required: true,
      outerOptions: [
        { id: "Absent", name: "Absent" },
        { id: "Present", name: "Present" },
      ],
    },
  ];

  const formButtons = ["cancel"];

  let module = getAssignedModule(location.pathname);
  let actionPermission = false;
  if (!module || module === "") {
    actionPermission = true;
  } else {
    let updatedModules = JSON.parse(
      localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
    );
    if (updatedModules[module]) {
      let modulePermissions = updatedModules[module].map((perm) => {
        if (typeof perm === "string") {
          return perm.toLowerCase();
        }
        return perm;
      });
      if (modulePermissions.includes("change status")) {
        actionPermission = true;
      }
    }
  }
  if (actionPermission) {
    formFields.push({
      type: "renderonly",
      name: "active",
      key: "active",
      label: "Active?",
      required: true,
      valueType: "boolean",
      noValue: "No",
      yesValue: "Yes",
    });
  }

  const handleSubmit = (values, { setSubmitting }) => {
    if (values.id === undefined) {
      eightAxios
        .post(ATTENDANCE_TYPE_URL, values)
        .then(() => {
          history.push(URLS.ATTENDANCE_TYPE);
        })
        .catch((error) => {
          setNotify({
            isOpen: true,
            message: error.response.data.message,
            type: "error",
          });
          setSubmitting(false);
        });
    } else {
      eightAxios
        .patch(`${ATTENDANCE_TYPE_URL}${params.id}/`, values)
        .then(() => {
          history.push(URLS.ATTENDANCE_TYPE);
        })
        .catch((error) => {
          setNotify({
            isOpen: true,
            message: error.response.data.message,
            type: "error",
          });
          setSubmitting(false);
        });
    }
  };

  return (
    <Form
      initialValues={initialValues}
      submitUrl={ATTENDANCE_TYPE_URL}
      outerSubmitHandler={handleSubmit}
      listRoute={URLS.ATTENDANCE_TYPE}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Attendance Type"
    />
  );
};

export default AttendanceTypeDetail;
